// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","mainLabel":"Button_mainLabel__IM2Jb","disabled":"Button_disabled__PUkNe"};